import axios from 'utils/axios';
import Appointment from "../types/appointment";

export const getAppointmentLogStatus = async (request: Appointment.GetConsultationStatusLogRequest): Promise<Appointment.AppointmentLog> => {
  const result = await axios.get(`/api/v1/appointments/${request.appointmentId}/statuslogs/${request.status}`);
  return result.data.data
};
